import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupConsentimentos(): void {
  applicationModuleRegistry.register({
    entry: 'consentimentos',
    id: 'consentimentos',
    name: 'beneficiary.consentimentos',
    route: Routes.CONSENTIMENTOS,
    order: 9,
    closeable: true,
  });
}
